export enum MEMBER_TYPES {
  APPLICANT = 'applicant',
  CHILD = 'child',
  DEPENDENT = 'dependent',
  GUARDIAN = 'guardian',
  SPOUSE = 'spouse'
}

export const MEMBER_TYPE_LABELS: Record<MEMBER_TYPES, string> = {
  [MEMBER_TYPES.APPLICANT]: 'Self',
  [MEMBER_TYPES.CHILD]: 'Child',
  [MEMBER_TYPES.DEPENDENT]: 'Dependent',
  [MEMBER_TYPES.GUARDIAN]: 'Guardian',
  [MEMBER_TYPES.SPOUSE]: 'Spouse'
};
